export default "__VITE_ASSET__CXse14gP__"